import { render, staticRenderFns } from "./page-sim.vue?vue&type=template&id=cbad5186&scoped=true&"
import script from "./page-sim.vue?vue&type=script&lang=js&"
export * from "./page-sim.vue?vue&type=script&lang=js&"
import style0 from "./page-sim.vue?vue&type=style&index=0&id=cbad5186&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbad5186",
  null
  
)

export default component.exports